import { render, staticRenderFns } from "./editPropertyRightRegistration.vue?vue&type=template&id=bbd60a0e&scoped=true"
import script from "./editPropertyRightRegistration.vue?vue&type=script&lang=js"
export * from "./editPropertyRightRegistration.vue?vue&type=script&lang=js"
import style0 from "./editPropertyRightRegistration.vue?vue&type=style&index=0&id=bbd60a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd60a0e",
  null
  
)

export default component.exports